var map = {
	"./12-reasons-why-argentina-for-giving-birth.jpg": 8410,
	"./airline-companies-to-fly-with.jpg": 8920,
	"./argentina-citizenship-after-giving-birth.jpg": 5369,
	"./assetsForPosts/card-mep-rate-in-argentina-blog-1.jpg": 4510,
	"./assetsForPosts/card-mep-rate-in-argentina-blog-2.jpg": 9529,
	"./assetsForPosts/card-mep-rate-in-argentina-blog-3.jpg": 5180,
	"./birth-stories-nightly-bronchospasm.jpg": 6818,
	"./birth-stories-pain-in-the-back-of-the-head.jpg": 3402,
	"./birth-stories-postpartum-bleeding.jpg": 6435,
	"./birth-stories-postpartum-preeclampsia.jpg": 897,
	"./buenos-aires-summer.jpg": 8328,
	"./card-mep-rate-in-argentina.jpg": 5665,
	"./challenges-in-argentina-to-give-birth.jpg": 8893,
	"./cheaper-life-argentina-blue-official.jpg": 2365,
	"./choosing-your-doctor.jpg": 9437,
	"./clothes-for-winter-in-buenos-aires.jpg": 5973,
	"./comparing-private-and-public-hospitals.jpg": 3425,
	"./differences-between-doula-and-midwife.jpg": 5400,
	"./documents-delivery-postal-service.jpg": 3972,
	"./first-vaccinations-for-babies.jpg": 7963,
	"./give-birth-in-argentina-changes-in-2025.jpg": 8206,
	"./give-birth-in-argentina-how-much-budget.jpg": 8127,
	"./home-birth-what-to-know.jpg": 8181,
	"./how-accompanying-works.jpg": 6030,
	"./how-much-time-birth-kid-documents.jpg": 5459,
	"./invierno-en-buenos-aires.jpg": 7471,
	"./kids-documents-explained.jpg": 8948,
	"./last-name-of-the-baby-in-hospital.jpg": 7049,
	"./museums-in-buenos-aires.jpg": 2382,
	"./optimize-your-budget.jpg": 7760,
	"./parents-documents-explained.jpg": 6856,
	"./partner-birth.jpg": 2753,
	"./trusting-doctors.jpg": 5178,
	"./types-of-rent.jpg": 70,
	"./what-documents-to-bring.jpg": 5283,
	"./what-happens-after-giving-birth.jpg": 6681,
	"./what-to-bring-to-flight.jpg": 2701,
	"./where-to-buy-food-in-ba.jpg": 1970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6939;